import { ComponentPropsWithoutRef } from "react";
import { FieldInputProps } from "formik";
import { RadioGroup } from "@headlessui/react";
import SpeckleLogoSvg from "../../speckle-logo.svg";
import FormRadio from "components/elements/Forms/FormRadio";

export default function SpeckleRadioInputModels(
  p: FieldInputProps<string> &
    ComponentPropsWithoutRef<typeof FormRadio> & {
      project: string;
      items: { value: string; label: string; description?: string }[];
      onSelect?(value: string): void;
    },
) {
  const { project, items, onSelect, onChange, value, ...rest } = p;

  function handleChange(newValue: string) {
    onChange(newValue);
    onSelect?.(newValue);
  }

  if (!items) return null;

  if (items.length === 0)
    return <div className="text-center text-sm text-gray-400">None</div>;

  return (
    <RadioGroup
      value={value}
      onChange={handleChange}
      aria-label="Models"
      {...rest}
    >
      <div className="flex select-none flex-row rounded-md border p-5 shadow-sm">
        <SpeckleLogoSvg className="mr-4 inline w-5" />
        <p className="w-full truncate text-sm">{project}</p>
      </div>
      <div className="relative ml-6 font-light">
        {items.map((item) => (
          <div
            key={item.value}
            className="group/model-card relative flex select-none"
          >
            <div
              className="absolute inset-y-0 border-l
                border-speckle-blue group-last/model-card:bottom-1/2"
            />
            <RadioGroup.Option
              value={item.value}
              className={({ checked, disabled }) =>
                `relative ml-6 mt-2 grow rounded-md border p-4 shadow-sm
                group-first/model-card:mt-5
                ${checked ? "border-speckle-blue" : ""}
                ${disabled ? "text-neutral-700" : "cursor-pointer hover:bg-gray-50"}`
              }
            >
              {({ checked }) => (
                <>
                  <div
                    className="absolute inset-y-1/2 -left-6 -ml-1 -mt-1 h-2 w-2
                    rounded-full bg-white shadow-[0_0_3px_0] shadow-speckle-blue"
                  />
                  <RadioGroup.Label className="cursor-[inherit]">
                    {item.label}
                  </RadioGroup.Label>
                  {item.description && (
                    <RadioGroup.Description>
                      {item.description}
                    </RadioGroup.Description>
                  )}
                </>
              )}
            </RadioGroup.Option>
          </div>
        ))}
      </div>
    </RadioGroup>
  );
}
